import { render, staticRenderFns } from "./ResponseCard.vue?vue&type=template&id=c460a2be&scoped=true&"
import script from "./ResponseCard.vue?vue&type=script&lang=js&"
export * from "./ResponseCard.vue?vue&type=script&lang=js&"
import style0 from "./ResponseCard.vue?vue&type=style&index=0&id=c460a2be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c460a2be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c460a2be')) {
      api.createRecord('c460a2be', component.options)
    } else {
      api.reload('c460a2be', component.options)
    }
    module.hot.accept("./ResponseCard.vue?vue&type=template&id=c460a2be&scoped=true&", function () {
      api.rerender('c460a2be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResponseCard.vue"
export default component.exports